var _defineProperty = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

module.exports = function (e) {
  var t = {};

  function a(r) {
    if (t[r]) return t[r].exports;
    var l = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(l.exports, l, l.exports, a), l.l = !0, l.exports;
  }

  return a.m = e, a.c = t, a.d = function (e, t, r) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, t) {
    if (1 & t && (e = a(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (a.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var l in e) {
      a.d(r, l, function (t) {
        return e[t];
      }.bind(null, l));
    }
    return r;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "", a(a.s = 51);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  51: function _(e, t, a) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var a in e) {
        Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      }
      return t.default = e, t;
    },
        l = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(a(1)),
        o = r(a(2)),
        i = l(a(52)),
        s = a(53),
        u = l(a(54)),
        c = l(a(5)),
        d = l(a(55)),
        f = a(4),
        m = o.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
      var e = _ref.theme;
      return e.wrapper;
    }),
        p = o.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), function (_ref2) {
      var e = _ref2.theme;
      return e.facade;
    }, function (_ref3) {
      var e = _ref3.multiple;
      return e && "max-height: 170px; overflow: scroll;";
    }, function (_ref4) {
      var e = _ref4.selectEnabled;
      return !e && "cursor: default;";
    }),
        v = o.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref5) {
      var e = _ref5.theme;
      return e.file;
    }),
        g = o.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
      var e = _ref6.theme;
      return e.icon;
    }),
        h = o.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref7) {
      var e = _ref7.theme;
      return e.recomendation;
    }),
        b = o.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref8) {
      var e = _ref8.theme;
      return e.rowItem;
    }),
        E = o.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref9) {
      var e = _ref9.theme;
      return e.colInfo;
    }),
        w = o.default.label(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref10) {
      var e = _ref10.theme;
      return e.infoLabel;
    }),
        y = o.default.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref11) {
      var e = _ref11.theme;
      return e.infoName;
    }),
        x = o.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref12) {
      var e = _ref12.theme;
      return e.previewUpload;
    }),
        N = o.default.img.attrs(function (_ref13) {
      var e = _ref13.src;
      return {
        src: e
      };
    })(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (_ref14) {
      var e = _ref14.theme;
      return e.imagePreview;
    }, function (_ref15) {
      var e = _ref15.multiple;
      return e ? "max-width: 240px;" : "width: 100%";
    }),
        O = o.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref16) {
      var e = _ref16.theme;
      return e.quitIcon;
    }),
        $ = o.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref17) {
      var e = _ref17.theme;
      return e.videoWrapper;
    }),
        P = o.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref18) {
      var e = _ref18.theme;
      return e.draggingOverlay;
    }),
        j = {
      cryptoMd5Method: function cryptoMd5Method(e) {
        return u.default.create().update(e).base64();
      },
      cryptoHexEncodedHash256: function cryptoHexEncodedHash256(e) {
        return s.sha256.create().update(e).hex();
      }
    },
        F = function F(e) {
      var _e$theme = e.theme,
          t = _e$theme === void 0 ? "Basic" : _e$theme,
          a = e.accept,
          _e$multiple = e.multiple,
          r = _e$multiple === void 0 ? !1 : _e$multiple,
          l = e.onChange,
          _e$maxMbFileSize = e.maxMbFileSize,
          s = _e$maxMbFileSize === void 0 ? 0 : _e$maxMbFileSize,
          u = e.customLabel,
          F = e.customErrorLabel,
          _e$multipart = e.multipart,
          _ = _e$multipart === void 0 ? !1 : _e$multipart,
          U = e.bucket,
          _e$apiURL = e.apiURL,
          D = _e$apiURL === void 0 ? "" : _e$apiURL,
          _e$s3path = e.s3path,
          R = _e$s3path === void 0 ? "/" : _e$s3path,
          _e$awsUrl = e.awsUrl,
          k = _e$awsUrl === void 0 ? "" : _e$awsUrl,
          _e$awsKey = e.awsKey,
          L = _e$awsKey === void 0 ? "AKIAJ5R6AKWKZ5XVGFAQ" : _e$awsKey,
          _e$awsRegion = e.awsRegion,
          M = _e$awsRegion === void 0 ? "us-west-2" : _e$awsRegion,
          _e$cloudfront = e.cloudfront,
          S = _e$cloudfront === void 0 ? !0 : _e$cloudfront,
          _e$computeContentMd = e.computeContentMd5,
          C = _e$computeContentMd === void 0 ? !0 : _e$computeContentMd,
          _e$disableWithData = e.disableWithData,
          q = _e$disableWithData === void 0 ? !1 : _e$disableWithData,
          _e$customRecommendati = e.customRecommendation,
          I = _e$customRecommendati === void 0 ? "" : _e$customRecommendati,
          _e$manualUploadOption = e.manualUploadOptions,
          A = _e$manualUploadOption === void 0 ? {
        enabled: !1,
        doUpload: !1
      } : _e$manualUploadOption,
          _e$recommendationNote = e.recommendationNote,
          T = _e$recommendationNote === void 0 ? function (_ref19) {
        var e = _ref19.customRecommendation,
            t = _ref19.extensionNames,
            a = _ref19.maxMbFileSize;
        return e || "Recommendation: Use high-quality, ".concat(t, " files ").concat(a ? "less than ".concat(a, "MB") : "");
      } : _e$recommendationNote,
          _e$onUploadStart = e.onUploadStart,
          z = _e$onUploadStart === void 0 ? function () {} : _e$onUploadStart,
          _e$onUploadProgress = e.onUploadProgress,
          K = _e$onUploadProgress === void 0 ? function () {} : _e$onUploadProgress,
          _e$onUploadError = e.onUploadError,
          W = _e$onUploadError === void 0 ? function () {} : _e$onUploadError,
          _e$onUploadFinish = e.onUploadFinish,
          B = _e$onUploadFinish === void 0 ? function (e) {
        return e;
      } : _e$onUploadFinish,
          _e$processFilename = e.processFilename,
          H = _e$processFilename === void 0 ? function (e) {
        return e.replace(/[^\w\d_\-.]+/gi, "");
      } : _e$processFilename,
          G = e.processAwsOptions,
          J = e.processAwsConfig,
          Q = e.isNextManual,
          V = e.showRemoveFile,
          X = _objectWithoutProperties(e, ["theme", "accept", "multiple", "onChange", "maxMbFileSize", "customLabel", "customErrorLabel", "multipart", "bucket", "apiURL", "s3path", "awsUrl", "awsKey", "awsRegion", "cloudfront", "computeContentMd5", "disableWithData", "customRecommendation", "manualUploadOptions", "recommendationNote", "onUploadStart", "onUploadProgress", "onUploadError", "onUploadFinish", "processFilename", "processAwsOptions", "processAwsConfig", "isNextManual", "showRemoveFile"]),
          _n$useState = n.useState([]),
          _n$useState2 = _slicedToArray(_n$useState, 2),
          Z = _n$useState2[0],
          Y = _n$useState2[1],
          _n$useState3 = n.useState(!1),
          _n$useState4 = _slicedToArray(_n$useState3, 2),
          ee = _n$useState4[0],
          te = _n$useState4[1],
          _n$useState5 = n.useState(0),
          _n$useState6 = _slicedToArray(_n$useState5, 2),
          ae = _n$useState6[0],
          re = _n$useState6[1],
          _n$useState7 = n.useState(!1),
          _n$useState8 = _slicedToArray(_n$useState7, 2),
          le = _n$useState8[0],
          ne = _n$useState8[1],
          oe = n.useRef(null),
          ie = n.useRef(null),
          se = n.useRef(null),
          ue = !q || 0 === Z.length,
          ce = function ce(e) {
        var t = 1024 * s * 1024;
        return 0 === s || s && e.size <= t;
      },
          de = function de(e) {
        Z.map(function (e) {
          return URL.revokeObjectURL(e.urlImagePreview);
        });
        var t = [];
        return Object.keys(e).forEach(function (a) {
          var r = e[a];

          if (ce(r)) {
            var _e = null;
            _e = URL.createObjectURL(r), r.urlImagePreview = _e, t.push(r);
          }
        }), t;
      },
          fe = n.useCallback(function (e, t) {
        var _ref20 = t ? e.dataTransfer : e.target,
            a = _ref20.files;

        if (Object.keys(a).length) {
          var _e2 = de(a);

          Y(_e2), l && l(_e2), !A.enabled && _ && se.current && 1 === a.length && ce(a[0]) && se.current.uploadFile();
        }
      }, [Z, s]),
          me = function me(e, t) {
        e.stopPropagation();

        var a = _toConsumableArray(Z);

        a.splice(t, 1), Y(a), l && l(a);
      },
          pe = n.useCallback(function (e) {
        e.preventDefault(), e.stopPropagation();
        var t = ae;
        t += 1, re(t), e.dataTransfer.items && e.dataTransfer.items.length > 0 && te(!0);
      }, [ae]),
          ve = n.useCallback(function (e) {
        e.preventDefault(), e.stopPropagation();
        var t = ae;
        t -= 1, re(t), 0 === t && te(!1);
      }, [ae]),
          ge = function ge(e) {
        e.preventDefault(), e.stopPropagation();
      },
          he = n.useCallback(function (e) {
        e.preventDefault(), e.stopPropagation(), te(!1), e.dataTransfer.files && e.dataTransfer.files.length > 0 && (oe.current.files = e.dataTransfer.files, fe(e, !0), e.dataTransfer.clearData(), re(0));
      }, [fe]);

      n.useEffect(function () {
        if ("DragAndDrop" === t) {
          var _e3 = ie.current;
          return _e3.addEventListener("dragenter", pe), _e3.addEventListener("dragleave", ve), _e3.addEventListener("dragover", ge), _e3.addEventListener("drop", he), function () {
            re(0), _e3.removeEventListener("dragenter", pe), _e3.removeEventListener("dragleave", ve), _e3.removeEventListener("dragover", ge), _e3.removeEventListener("drop", he);
          };
        }
      }, [pe, ve, he, t]), n.useEffect(function () {
        A.enabled && A.doUpload && se.current && se.current.uploadFile();
      }, [A]);

      var be = !Z.length && "DragAndDrop" === t && (s || a),
          Ee = {
        extensionNames: function () {
          var e = "";

          if (a) {
            var _t = a.split(","),
                _r = [];

            _t.forEach(function (t) {
              var a = t.split("/");
              _r.push("*" !== a[1] ? a[1] : a[0]), e = _r.join(", ").replace(/, ([^,]*)$/, " or $1");
            });
          }

          return e;
        }(),
        maxMbFileSize: s,
        customRecommendation: I
      },
          we = _objectSpread(_objectSpread({}, j), {}, {
        bucket: U,
        aws_key: L,
        aws_url: k,
        awsRegion: M,
        cloudfront: S,
        computeContentMd5: C
      });

      return n.default.createElement(o.ThemeProvider, {
        theme: f.isObject(t) ? t : d.default[t]
      }, n.default.createElement(m, {
        "data-testid": "lego-styled-filer",
        className: "lego-filer Filer"
      }, n.default.createElement(p, {
        "data-testid": "lego-filer-facade",
        onClick: function onClick() {
          oe && ue && oe.current.click();
        },
        className: "Filer-facade",
        ref: ie,
        multiple: r,
        selectEnabled: ue
      }, Z.length > 0 ? "DragAndDrop" === t ? Z.map(function (e, t) {
        return n.default.createElement(b, {
          key: t,
          className: "row-item-upload"
        }, n.default.createElement(E, {
          className: "row-item-col-info"
        }, n.default.createElement(w, null, "File Name:"), n.default.createElement(y, null, e.name)), n.default.createElement(x, {
          className: "preview-upload"
        }, e.type.match("video.*") ? n.default.createElement($, {
          className: "file-preview"
        }, n.default.createElement("video", {
          controls: !0
        }, n.default.createElement("source", {
          src: e.urlImagePreview
        }))) : n.default.createElement(N, {
          className: "file-preview",
          src: e.urlImagePreview,
          alt: "img preview",
          multiple: r
        }), n.default.createElement(O, {
          className: "quit-icon",
          onClick: function onClick(e) {
            return me(e, Number(t));
          }
        }, n.default.createElement(c.default, {
          name: "close",
          color: "white",
          size: 12
        }))));
      }) : Z.map(function (e, t) {
        return n.default.createElement(v, {
          className: "Filer-file",
          key: t
        }, e.name, V && n.default.createElement(O, {
          onClick: function onClick(e) {
            return me(e, Number(t));
          },
          className: "removeIcon"
        }, n.default.createElement(c.default, {
          name: "close",
          color: "white",
          size: 12
        })));
      }) : u || n.default.createElement(v, {
        "data-testid": "lego-filer-file",
        className: "Filer-default-text"
      }, "Select file"), n.default.createElement(g, {
        "data-testid": "lego-filer-icon-wrapper",
        className: "Filer-icon"
      }, n.default.createElement(c.default, {
        "data-testid": "lego-filer-icon",
        name: "plus",
        color: "white",
        size: 30
      })), be && n.default.createElement(h, {
        className: "filer-recommendation"
      }, T(Ee)), le && F, "DragAndDrop" === t && ee && n.default.createElement(P, null, "Drop here")), _ ? n.default.createElement(i.default, Object.assign({
        ref: se,
        inputRef: oe,
        evaporateOptions: we,
        signingUrl: (ye = D, ye + "/generate-v4-signature"),
        accept: a,
        s3path: R,
        preprocess: function preprocess(e, t) {
          z(e, t);
          var a = de([e]);
          Y(a), Q || t(e);
        },
        onProgress: K,
        onError: W,
        onFinish: B,
        contentDisposition: "auto",
        scrubFilename: H,
        processEvaporateOptions: G,
        processEvaporateConfig: J,
        id: "videoUploader",
        hidden: !0,
        autoUpload: !1,
        onChange: fe
      }, X)) : n.default.createElement("input", Object.assign({
        ref: oe,
        type: "file",
        "data-testid": "lego-filer-input",
        className: "Filer-input",
        onChange: fe,
        accept: a,
        multiple: r,
        disabled: !ue,
        hidden: !0
      }, X))));
      var ye;
    };

    F.defaultProps = {}, t.default = F;
  },
  52: function _(e, t) {
    e.exports = require("react-s3-uploader-multipart");
  },
  53: function _(e, t) {
    e.exports = require("js-sha256");
  },
  54: function _(e, t) {
    e.exports = require("js-md5");
  },
  55: function _(e, t) {
    e.exports = require("../../themes/Filer.theme");
  }
});